/* nl-sticky-rail — a sticky offer rail beside a long article: the offer card
   shows first; below it a filler block collapses while the rail's reviews rise
   into view as the reader reaches a trigger heading.

   Root:      [data-nl-rail]                 the sticky card wrapper
              data-nl-rail-trigger="<id>"    id of the heading that starts the reveal
              data-nl-rail-min="1024"        viewport width from which it runs (default 1024)
              data-nl-rail-extra="32"        extra space under the offer when sizing the filler (default 32)
   Children:  [data-nl-rail-offer]   the always-visible offer card
              [data-nl-rail-filler]  collapsing block (optional)
              [data-nl-rail-reviews] revealed block (optional)
   Below the minimum width everything is left at natural size (no inline styles).
   Lifecycle: re-inits on shopify:section:load, tears down on :unload. */
(function () {
  var instances = {};

  function init(root) {
    if (!root || root.__nlRail) return;
    var min = parseInt(root.getAttribute('data-nl-rail-min'), 10) || 1024;
    var extra = parseInt(root.getAttribute('data-nl-rail-extra'), 10);
    if (isNaN(extra)) extra = 32;
    var offer = root.querySelector('[data-nl-rail-offer]');
    var filler = root.querySelector('[data-nl-rail-filler]');
    var revs = root.querySelector('[data-nl-rail-reviews]');
    var triggerId = root.getAttribute('data-nl-rail-trigger');
    var G = 0;
    var section = root.closest('[id^="shopify-section-"]') || document;

    function trigger() {
      return triggerId ? document.getElementById(triggerId) : null;
    }
    function desktop() { return window.innerWidth >= min; }

    function reset() {
      if (filler) filler.style.height = '';
      root.style.top = '';
    }
    function measure() {
      if (!offer || !filler || !desktop()) { reset(); return; }
      filler.style.height = 'auto';
      var natural = filler.scrollHeight;
      G = Math.max(natural, window.innerHeight - offer.offsetHeight - extra);
      update();
    }
    function update() {
      var t = trigger();
      if (!offer || !filler || !t || !desktop()) { reset(); return; }
      var vh = window.innerHeight;
      var trigTop = t.getBoundingClientRect().top + window.scrollY;
      var p = (window.scrollY - (trigTop - 0.9 * vh)) / (G || 1);
      p = Math.max(0, Math.min(1, p));
      filler.style.height = (G - p * (G - 10)) + 'px';
      var finalH = offer.offsetHeight + 10 + (revs ? revs.offsetHeight : 0);
      var endTop = Math.min(16, vh - finalH - 16);
      root.style.top = (16 + p * (endTop - 16)) + 'px';
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    measure();

    root.__nlRail = true;
    instances[section.id || 'x'] = function () {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', measure);
      window.removeEventListener('load', measure);
      reset();
      delete root.__nlRail;
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-nl-rail]'), init);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector && e.target.querySelector('[data-nl-rail]');
    if (!r) return;
    var k = e.target.id || 'x';
    if (instances[k]) { instances[k](); delete instances[k]; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
